import { DirectBudgetCard, DirectBudgetRollupRow, DirectBudgetRow } from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const fetchDirectBudgetCards = async (filters: any): Promise<DirectBudgetCard> => {
  const json = await postBiz({ s: 'directbudget', a: 'cards', ...filters });
  return json.sd || json.result || json;
};

export const fetchDirectBudgetRows = async (filters: any): Promise<DirectBudgetRow[]> => {
  const json = await postBiz({ s: 'directbudget', a: 'find', ...filters, pgo: 0, pgl: 500 });
  return rows(json);
};

export const fetchDirectBudgetRollup = async (filters: any): Promise<DirectBudgetRollupRow[]> => {
  const json = await postBiz({ s: 'directbudget', a: 'rollup', ...filters });
  return rows(json);
};

export const saveDirectBudgetRows = async (filters: any, records: any[]) => {
  return postBiz({ s: 'directbudget', a: 'bulksave', ...filters, rcd: records });
};
